/// <reference path="DOMAttached.js" />
/// <reference path="TextResource.js" />
/// <reference path="UrlTemplate.js" />

var SuperDragonFireServerInterface = null;

class SuperDragonFire extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.valueParameterName = "PLH_number";
		this.actionParameterName = "PLH_Action";
		SuperDragonFireServerInterface = this;
	}

	storeMusicVolume(volume, onSuccessCallback, onFailureCallback) {
		// Apparently there was a plan to store the volume here and then restore it when the game opens next time. However, this was never implemented.
	}

	storeSoundVolume(volume, onSuccessCallback, onFailureCallback) {
		// Apparently there was a plan to store the volume here and then restore it when the game opens next time. However, this was never implemented.
	}

	hasMemberEnoughMoney(amount, onTrueCallback, onFalseCallback) {
		// action: 0 = check for enough money
		axios(new UrlTemplate(this.options.serverCommunicationURL).r(this.valueParameterName, amount).r(this.actionParameterName, 0).url, {
			method: 'get'
		}).then((response) => {
			if (response.data.success) {
				onTrueCallback();
			} else {
				onFalseCallback();
			}
		});
	}

	callForMoneyTransaction(amount, onSuccessCallback, onFailureCallback) {
		// action: 1 = book money now/request payment
		axios(new UrlTemplate(this.options.serverCommunicationURL).r(this.valueParameterName, amount).r(this.actionParameterName, 1).url, {
			method: 'get'
		}).then((response) => {
			// for now, we assume everything went okay
			// as we just checked if the user has enough money
		});
	}

	storeScore(score, onSuccessCallback, onFailureCallback) {
		// action: 2 = store score
		axios(new UrlTemplate(this.options.serverCommunicationURL).r(this.valueParameterName, score).r(this.actionParameterName, 2).url, {
			method: 'get'
		}).then((response) => {
			onSuccessCallback();
		});
	}

	storeItem(itemLevel, itemID, onSuccessCallback, onFailureCallback) { // itemID has to be > 100
		// itemID will be processed in super dragon fire navigation node
		axios(new UrlTemplate(this.options.serverCommunicationURL).r(this.valueParameterName, itemLevel).r(this.actionParameterName, itemID).url, {
			method: 'get'
		}).then((response) => {
			// for now, we assume everything went okay
			// as we just checked if the user has enough money
		});
	}
}
